import changeSort from '../actions/changeSort.js'

export default [changeSort]



// WEBPACK FOOTER //
// ./src/modules/user/chains/changeSort.js